import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AbbrevProvinceState: { input: string; output: string; }
  Answers: { input: any; output: any; }
  Date: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  JSONObject: { input: any; output: any; }
  NonEmptyString: { input: string; output: string; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  ObjectID: { input: string; output: string; }
  PolicyDescription: { input: "CGL" | "E&O" | "D&O" | "Crime" | "Cyber Liability" | "Legal Expense" | "Medical Malpractice"; output: "CGL" | "E&O" | "D&O" | "Crime" | "Cyber Liability" | "Legal Expense" | "Medical Malpractice"; }
  PositiveFloat: { input: number; output: number; }
  PostalCode: { input: string; output: string; }
  ProvinceState: { input: string; output: string; }
  TimeZone: { input: string; output: string; }
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type ActiveRenewalData = {
  __typename?: 'ActiveRenewalData';
  stripePlatformAccount: Scalars['String']['output'];
};

export type ActiveRenewalFailureData = {
  __typename?: 'ActiveRenewalFailureData';
  applicationIdStr: Scalars['String']['output'];
  carrierPartner?: Maybe<Scalars['String']['output']>;
  charge_total: Scalars['Float']['output'];
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  encryptedData: Scalars['String']['output'];
  invoiceIdStr: Scalars['String']['output'];
  paymentIdStr: Scalars['String']['output'];
  policyFoxdenId: Scalars['String']['output'];
  quoteIdStr: Scalars['String']['output'];
  recordedEmail: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  stripePlatformAccount: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  useCardForRenewals: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  region: Scalars['ProvinceState']['output'];
  street: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  region: Scalars['ProvinceState']['input'];
  street: Scalars['String']['input'];
};

/**
 * Result of a broker-initiated hosted Stripe Checkout Session. The broker
 * frontend redirects to `url`; `sessionId` is the Stripe Checkout Session id.
 */
export type BrokerCheckoutSessionResult = {
  __typename?: 'BrokerCheckoutSessionResult';
  sessionId: Scalars['String']['output'];
  stripePlatformAccount: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BusinessAddressChange = {
  __typename?: 'BusinessAddressChange';
  newAddress: UnderwritingAddress;
};

export type CalChangedQuoteQuoteInput = {
  objectId: Scalars['ObjectID']['input'];
  results: CalChangedQuoteQuoteResultsInput;
};

export type CalChangedQuoteQuoteResultsInput = {
  calculations: MunichCalculationsInput;
  coverageExpiryDate: Scalars['Date']['input'];
  coverageStartDate: Scalars['Date']['input'];
};

export type CancellationQuoteResponse = {
  __typename?: 'CancellationQuoteResponse';
  quoteExpireDate: Scalars['Date']['output'];
  quoteNumber: Scalars['String']['output'];
  results: CancellationQuoteResults;
};

export type CancellationQuoteResults = {
  __typename?: 'CancellationQuoteResults';
  /** Prorated premiums */
  calculations: MunichProratedCalculations;
  coverageExpiryDate: Scalars['Date']['output'];
  coverageStartDate: Scalars['Date']['output'];
  prevQuoteObjectId: Scalars['ObjectID']['output'];
};

export type CancellationSuccess = {
  __typename?: 'CancellationSuccess';
  result: Scalars['Boolean']['output'];
};

export enum CancellationTrigger {
  Carrier = 'carrier',
  Client = 'client'
}

export type CancelledRenewalData = {
  __typename?: 'CancelledRenewalData';
  cancelledAt: Scalars['String']['output'];
};

export type ChangeCardSessionInput = {
  brokerEmail?: InputMaybe<Scalars['String']['input']>;
  policyNumber: Scalars['String']['input'];
  /**
   * When true, and a past-due installment exists, the change-card Checkout also
   * settles that single arrears installment on the new card. Omitted / null is
   * treated as false, so a plain card swap only saves the card and never charges.
   */
  settleOutstanding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangedQuoteResponse = {
  __typename?: 'ChangedQuoteResponse';
  quoteExpireDate: Scalars['Date']['output'];
  quoteNumber: Scalars['String']['output'];
  results: ChangedQuoteResults;
};

export type ChangedQuoteResults = {
  __typename?: 'ChangedQuoteResults';
  /** Prorated premiums */
  calculations: MunichProratedCalculations;
  coverageExpiryDate: Scalars['Date']['output'];
  coverageStartDate: Scalars['Date']['output'];
  /** The quote result for the input answers */
  curQuoteResults: QuoteResults;
  prevQuoteObjectId: Scalars['ObjectID']['output'];
};

export type ChargeSuccess = {
  __typename?: 'ChargeSuccess';
  getInvoiceDeciderResult: GetInvoiceSuccess;
  userPaymentPlanOptionDeciderResult: GetUserPaymentOptionSuccess;
};

export enum ChildCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Errors & Omissions */
  Eo = 'EO',
  /** Hardware / Software */
  Hwsw = 'HWSW',
  /** Limited Pollution */
  LimitedPollution = 'LimitedPollution',
  /** Lock Key Business Items */
  LockKeyBusinessItems = 'LockKeyBusinessItems',
  /** Lock Key Contractors */
  LockKeyContractors = 'LockKeyContractors',
  /** Photo Video Endorsement */
  PhotoVideoEndor = 'PhotoVideoEndor',
  /** Physical Loss */
  PhysicalLoss = 'PhysicalLoss',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft',
  /** Unscheduled Business Personal PropertyP */
  UnscheduledBpp = 'UnscheduledBPP',
  /** Unscheduled Contractors */
  UnscheduledContractors = 'UnscheduledContractors',
  /** Unscheduled hardware/software */
  UnscheduledHwsw = 'UnscheduledHWSW',
  /** Unscheduled Small Tools */
  UnscheduledSmallTools = 'UnscheduledSmallTools',
  /** Valuable Papers */
  ValuablePapers = 'ValuablePapers'
}

export type CoiAdditionalInsuredInput = {
  address: UnderwritingAddressInput;
  name: Scalars['NonEmptyString']['input'];
};

export type CollectPaymentSessionInput = {
  brokerEmail?: InputMaybe<Scalars['String']['input']>;
  collectionType: PaymentCollectionType;
  policyNumber: Scalars['String']['input'];
};

/**
 * Returned when one or more products in the group are already bound. In the
 * legacy single-product flow, `items` has length 1; multi-prod groups list
 * one entry per bound product so the frontend can surface every
 * already-completed product at once.
 */
export type CompletionData = {
  __typename?: 'CompletionData';
  isCompleted: Scalars['Boolean']['output'];
  items: Array<CompletionDataItem>;
};

export type CompletionDataItem = {
  __typename?: 'CompletionDataItem';
  policyIdStr: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
};

export type ContinuePaymentSessionInput = {
  applicationIdStr: Scalars['String']['input'];
  carrierPartner?: InputMaybe<Scalars['String']['input']>;
  charge_total: Scalars['Float']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  encryptedData?: InputMaybe<Scalars['String']['input']>;
  invoiceIdStr: Scalars['String']['input'];
  paymentIdStr: Scalars['String']['input'];
  policyFoxdenId: Scalars['String']['input'];
  quoteIdStr: Scalars['String']['input'];
  recordedEmail: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  stripePlatformAccount: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  useCardForRenewals: Scalars['Boolean']['input'];
};

export type CoverageLimit = {
  __typename?: 'CoverageLimit';
  coverage: ChildCoverageType;
  newLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
  oldLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

export type CoverageUpdateChange = {
  __typename?: 'CoverageUpdateChange';
  coverage: ParentCoverageType;
  limits: Array<CoverageLimit>;
};

export type CreatePaymentInput = {
  invoiceId: Scalars['ObjectID']['input'];
  method: PaymentMethod;
  provider: Provider;
};

export type CreatePaymentSessionInput = {
  /**
   * Either an `Invoice._id` (legacy single-product flow) or an
   * `ApplicationGroup._id` (multi-prod). The controller uses
   * `resolveId` to disambiguate at runtime.
   */
  invoiceIdOrGroupId: Scalars['ObjectID']['input'];
  method: PaymentMethod;
  paymentPlanId: Scalars['NonNegativeFloat']['input'];
  useCardForRenewals: Scalars['Boolean']['input'];
};

export enum CreateRefundableSequenceErrorKind {
  /** No Valid PaymentResult under this Policy */
  NoValidPaymentResult = 'NoValidPaymentResult'
}

/** Currencies that are supported by Foxden. */
export enum Currency {
  Cad = 'CAD',
  Usd = 'USD'
}

export type DocumentDownloadLink = {
  __typename?: 'DocumentDownloadLink';
  COI: Scalars['String']['output'];
  PaymentReceipt: Scalars['String']['output'];
  T_CDocument: Scalars['String']['output'];
  policyDocument: Scalars['String']['output'];
};

export type DocumentInformation = {
  __typename?: 'DocumentInformation';
  documentDownloadLink: DocumentDownloadLink;
  policyDetails: PolicyDetail;
};

export type EndorsementChange = BusinessAddressChange | CoverageUpdateChange | MailingAddressChange;

export enum FlowKind {
  Cancellation = 'Cancellation',
  /** This means in endorsement flow, we need to charge clients */
  Charge = 'Charge',
  /** This means new business flow. */
  Initial = 'Initial',
  /** This means in endorsement flow, we need to refund clients */
  RefundFullPay = 'RefundFullPay',
  /** This means in endorsement flow, we need to refund clients */
  RefundInstallment = 'RefundInstallment',
  /** This means renewal flow. */
  Renewal = 'Renewal',
  /** This means in endorsement flow, we need to waive */
  Waive = 'Waive'
}

export type FoxdenError = {
  __typename?: 'FoxdenError';
  fileName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GetFlowKindSuccess = {
  __typename?: 'GetFlowKindSuccess';
  flowKind: FlowKind;
  isExpired: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  policyFoxdenId: Scalars['String']['output'];
  policyRemoval: PolicyRemoval;
  transactionType: Scalars['String']['output'];
};

/** The error responses for getInvoice. Instead of revealing the data we just return a flag. */
export enum GetInvoiceErrorKind {
  /** This means invoiceId doesn't match our database. Record doesn't exist. */
  NotFound = 'NotFound'
}

export type GetInvoiceResults = FoxdenError | GetInvoiceSuccess;

export type GetInvoiceSuccess = {
  __typename?: 'GetInvoiceSuccess';
  effectiveDate?: Maybe<Scalars['String']['output']>;
  invoiceInfo: InvoiceInfo;
  isExpired: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isRenewalReserved: Scalars['Boolean']['output'];
  policyFoxdenId?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['TimeZone']['output'];
  transactionStartDate?: Maybe<Scalars['String']['output']>;
  useCardForRenewals?: Maybe<Scalars['Boolean']['output']>;
};

export type GetPaymentStatusResults = FoxdenError | PaymentStatus;

export type GetPolicyTaxServiceFeeRateResults = FoxdenError | GetPolicyTaxServiceFeeRateSuccess;

export type GetPolicyTaxServiceFeeRateSuccess = {
  __typename?: 'GetPolicyTaxServiceFeeRateSuccess';
  policyFeeRate: Scalars['Float']['output'];
  serviceFeeRate: Scalars['Float']['output'];
  surchargeRate: Scalars['Float']['output'];
  taxRate: Scalars['Float']['output'];
};

export type GetUniqueValueUnderPolicyNumberResults = FoxdenError | UniqueValueUnderPolicyNumber;

export type GetUserPaymentOptionSuccess = {
  __typename?: 'GetUserPaymentOptionSuccess';
  userPaymentPlanOption: Array<UserPaymentPlanOption>;
};

export enum IdType {
  Claim = 'Claim',
  Invoice = 'Invoice',
  Policy = 'Policy',
  Quote = 'Quote',
  Transaction = 'Transaction'
}

export type InactiveRenewalData = {
  __typename?: 'InactiveRenewalData';
  effectiveDate: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
};

export type InitialSuccess = {
  __typename?: 'InitialSuccess';
  getInvoiceDeciderResult: GetInvoiceSuccess;
  userPaymentPlanOptionDeciderResult: GetUserPaymentOptionSuccess;
};

export enum InstallmentFrequency {
  Annual = 'Annual',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

/** TODO: Update currency type, todo item is to replace currency with real credit card fee in backend */
export type InvoiceClient = {
  __typename?: 'InvoiceClient';
  address: Address;
};

export type InvoiceClientInput = {
  address: AddressInput;
  contactNumber: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
  name: NameInput;
  namedInsured: Scalars['NonEmptyString']['input'];
};

export type InvoiceInfo = {
  __typename?: 'InvoiceInfo';
  client?: Maybe<InvoiceClient>;
  currency: Scalars['String']['output'];
  glSurcharge: Scalars['Float']['output'];
  imSurcharge: Scalars['Float']['output'];
  invoiceDate: Scalars['Date']['output'];
  invoiceNumber: Scalars['String']['output'];
  policyFee: Scalars['Float']['output'];
  quoteNumber: Scalars['String']['output'];
  surcharge: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  totalPremium: Scalars['Float']['output'];
};

export type InvoiceInfoInput = {
  client: InvoiceClientInput;
  glPolicyFee: Scalars['Float']['input'];
  glPolicyFeeTax: Scalars['Float']['input'];
  glSurcharge: Scalars['Float']['input'];
  imPolicyFee: Scalars['Float']['input'];
  imPolicyFeeTax: Scalars['Float']['input'];
  imSurcharge: Scalars['Float']['input'];
  invoiceDate: Scalars['Date']['input'];
  invoiceNumber: Scalars['String']['input'];
  policyDetails: InvoicePolicyDetailsInput;
  policyFee: Scalars['Float']['input'];
  policyFeeTax: Scalars['Float']['input'];
  quoteNumber: Scalars['String']['input'];
  surcharge: Scalars['Float']['input'];
  tax: Scalars['Float']['input'];
  totalPremium: Scalars['Float']['input'];
};

export type InvoicePolicyDetailsInput = {
  description: Array<Scalars['PolicyDescription']['input']>;
  effectiveDate: Scalars['Date']['input'];
  notes: Scalars['String']['input'];
};

export type IsExpired = {
  __typename?: 'IsExpired';
  isExpired: Scalars['Boolean']['output'];
};

export type IsPaid = {
  __typename?: 'IsPaid';
  policyNumber: Scalars['String']['output'];
};

export type MailingAddressChange = {
  __typename?: 'MailingAddressChange';
  newAddress: UnderwritingAddress;
};

export type MunichCalculations = {
  __typename?: 'MunichCalculations';
  GL: MunichGlCalculations;
  IM: MunichImCalculations;
  totalPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichCalculationsInput = {
  GL: MunichGlCalculationsInput;
  IM: MunichImCalculationsInput;
  totalPremium: Scalars['NonNegativeFloat']['input'];
};

export type MunichGlAggregations = {
  __typename?: 'MunichGLAggregations';
  abuseAndMolestationPremium: Scalars['NonNegativeFloat']['output'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['NonNegativeFloat']['output'];
  eoPremium: Scalars['NonNegativeFloat']['output'];
  pollutionPremium: Scalars['NonNegativeFloat']['output'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['NonNegativeFloat']['output'];
  unmannedAircraftPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichGlAggregationsInput = {
  abuseAndMolestationPremium: Scalars['NonNegativeFloat']['input'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['NonNegativeFloat']['input'];
  eoPremium: Scalars['NonNegativeFloat']['input'];
  pollutionPremium: Scalars['NonNegativeFloat']['input'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['NonNegativeFloat']['input'];
  unmannedAircraftPremium: Scalars['NonNegativeFloat']['input'];
};

export type MunichGlCalculations = {
  __typename?: 'MunichGLCalculations';
  aggregations: MunichGlAggregations;
  labels: MunichGlRateLabels;
};

export type MunichGlCalculationsInput = {
  aggregations: MunichGlAggregationsInput;
  labels: MunichGlRateLabelsInput;
};

export type MunichGlProratedAggregations = {
  __typename?: 'MunichGLProratedAggregations';
  abuseAndMolestationPremium: Scalars['Float']['output'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['Float']['output'];
  eoPremium: Scalars['Float']['output'];
  pollutionPremium: Scalars['Float']['output'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['Float']['output'];
  unmannedAircraftPremium: Scalars['Float']['output'];
};

export type MunichGlProratedCalculations = {
  __typename?: 'MunichGLProratedCalculations';
  aggregations: MunichGlProratedAggregations;
  labels: MunichGlProratedRateLabels;
};

export type MunichGlProratedRateLabels = {
  __typename?: 'MunichGLProratedRateLabels';
  cglAdditionalLimitsPremium: Scalars['NonNegativeFloat']['output'];
  cglMiniAdditionalPremium: Scalars['NonNegativeFloat']['output'];
  cglPremPremium: Scalars['NonNegativeFloat']['output'];
  cglProdPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichGlRateLabels = {
  __typename?: 'MunichGLRateLabels';
  abuseMolestationLabels: Scalars['JSONObject']['output'];
  cglAdditionalLimitsLabels: Scalars['JSONObject']['output'];
  cglAdditionalLimitsPremium: Scalars['NonNegativeFloat']['output'];
  cglMeetMinLabels: Scalars['JSONObject']['output'];
  cglMiniAdditionalPremium: Scalars['NonNegativeFloat']['output'];
  /** TODO: types can be more specific */
  cglPremLabels: Scalars['JSONObject']['output'];
  /** We can remove these fields or keep these, they are already in the sub labels */
  cglPremPremium: Scalars['NonNegativeFloat']['output'];
  cglProdLabels: Scalars['JSONObject']['output'];
  cglProdPremium: Scalars['NonNegativeFloat']['output'];
  eoLabels: Scalars['JSONObject']['output'];
  pollutionLiabLabels: Scalars['JSONObject']['output'];
  unmannedAircraftLabels: Scalars['JSONObject']['output'];
};

export type MunichGlRateLabelsInput = {
  abuseMolestationLabels: Scalars['JSONObject']['input'];
  cglAdditionalLimitsLabels: Scalars['JSONObject']['input'];
  cglAdditionalLimitsPremium: Scalars['NonNegativeFloat']['input'];
  cglMeetMinLabels: Scalars['JSONObject']['input'];
  cglMiniAdditionalPremium: Scalars['NonNegativeFloat']['input'];
  /** TODO: types can be more specific */
  cglPremLabels: Scalars['JSONObject']['input'];
  /** We can remove these fields or keep these, they are already in the sub labels */
  cglPremPremium: Scalars['NonNegativeFloat']['input'];
  cglProdLabels: Scalars['JSONObject']['input'];
  cglProdPremium: Scalars['NonNegativeFloat']['input'];
  eoLabels: Scalars['JSONObject']['input'];
  pollutionLiabLabels: Scalars['JSONObject']['input'];
  unmannedAircraftLabels: Scalars['JSONObject']['input'];
};

export type MunichImAggregations = {
  __typename?: 'MunichIMAggregations';
  /** It's the total premium (adjusted with minimum premium) - premiums for additional coverages */
  adjustBasePremium: Scalars['NonNegativeFloat']['output'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['NonNegativeFloat']['output'];
  /** Additional Endorsements */
  photographyAndVideographyPremium: Scalars['NonNegativeFloat']['output'];
  /** Additional Endorsements */
  physicalLossPremium: Scalars['NonNegativeFloat']['output'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['NonNegativeFloat']['output'];
  /** Additional Endorsements */
  valualePapersPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichImAggregationsInput = {
  /** It's the total premium (adjusted with minimum premium) - premiums for additional coverages */
  adjustBasePremium: Scalars['NonNegativeFloat']['input'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['NonNegativeFloat']['input'];
  /** Additional Endorsements */
  photographyAndVideographyPremium: Scalars['NonNegativeFloat']['input'];
  /** Additional Endorsements */
  physicalLossPremium: Scalars['NonNegativeFloat']['input'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['NonNegativeFloat']['input'];
  /** Additional Endorsements */
  valualePapersPremium: Scalars['NonNegativeFloat']['input'];
};

export type MunichImCalculations = {
  __typename?: 'MunichIMCalculations';
  aggregations: MunichImAggregations;
  labels: MunichImRateLabels;
};

export type MunichImCalculationsInput = {
  aggregations: MunichImAggregationsInput;
  labels: MunichImRateLabelsInput;
};

export type MunichImProratedAggregations = {
  __typename?: 'MunichIMProratedAggregations';
  /** It's the total premium (adjusted with minimum premium) - premiums for additional coverages */
  adjustBasePremium: Scalars['Float']['output'];
  /** This is the premium for the required coverage. */
  basePremium: Scalars['Float']['output'];
  /** Additional Endorsements */
  photographyAndVideographyPremium: Scalars['Float']['output'];
  /** Additional Endorsements */
  physicalLossPremium: Scalars['Float']['output'];
  /** This is the premium including all additional coverages. */
  totalPremium: Scalars['Float']['output'];
  /** Additional Endorsements */
  valualePapersPremium: Scalars['Float']['output'];
};

export type MunichImProratedCalculations = {
  __typename?: 'MunichIMProratedCalculations';
  aggregations: MunichImProratedAggregations;
  labels: MunichImProratedRateLabels;
};

export type MunichImProratedRateLabels = {
  __typename?: 'MunichIMProratedRateLabels';
  /** For contractors */
  contractorsLockAndKeyPremium: Scalars['NonNegativeFloat']['output'];
  /** For non-contractors */
  hardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['output'];
  /** For non-contractors */
  lockAndKeyPremium: Scalars['NonNegativeFloat']['output'];
  miniAddPremium: Scalars['NonNegativeFloat']['output'];
  miniPremium: Scalars['NonNegativeFloat']['output'];
  /** For non-contractors */
  unscheduledBPPPremium: Scalars['NonNegativeFloat']['output'];
  /** For contractors */
  unscheduledContractorsEquipmentPremium: Scalars['NonNegativeFloat']['output'];
  /** For contractors */
  unscheduledHardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['output'];
  /** For contractors */
  unscheduledSmallToolsPremium: Scalars['NonNegativeFloat']['output'];
};

export type MunichImRateLabels = {
  __typename?: 'MunichIMRateLabels';
  contractorsLockAndKeyLabels: Scalars['JSONObject']['output'];
  /** For contractors */
  contractorsLockAndKeyPremium: Scalars['NonNegativeFloat']['output'];
  hardwareAndSoftwareLabels: Scalars['JSONObject']['output'];
  /** For non-contractors */
  hardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['output'];
  lockAndKeyLabels: Scalars['JSONObject']['output'];
  /** For non-contractors */
  lockAndKeyPremium: Scalars['NonNegativeFloat']['output'];
  miniAddPremium: Scalars['NonNegativeFloat']['output'];
  miniPremium: Scalars['NonNegativeFloat']['output'];
  photographyAndVideographyLebels: Scalars['JSONObject']['output'];
  physicalLossLabels: Scalars['JSONObject']['output'];
  unscheduledBPPLabels: Scalars['JSONObject']['output'];
  /** For non-contractors */
  unscheduledBPPPremium: Scalars['NonNegativeFloat']['output'];
  unscheduledContractorsEquipmentLebels: Scalars['JSONObject']['output'];
  /** For contractors */
  unscheduledContractorsEquipmentPremium: Scalars['NonNegativeFloat']['output'];
  unscheduledHardwareAndSoftwareLabels: Scalars['JSONObject']['output'];
  /** For contractors */
  unscheduledHardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['output'];
  unscheduledSmallToolsLebels: Scalars['JSONObject']['output'];
  /** For contractors */
  unscheduledSmallToolsPremium: Scalars['NonNegativeFloat']['output'];
  valualePapersLebels: Scalars['JSONObject']['output'];
};

export type MunichImRateLabelsInput = {
  contractorsLockAndKeyLabels: Scalars['JSONObject']['input'];
  /** For contractors */
  contractorsLockAndKeyPremium: Scalars['NonNegativeFloat']['input'];
  hardwareAndSoftwareLabels: Scalars['JSONObject']['input'];
  /** For non-contractors */
  hardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['input'];
  lockAndKeyLabels: Scalars['JSONObject']['input'];
  /** For non-contractors */
  lockAndKeyPremium: Scalars['NonNegativeFloat']['input'];
  miniAddPremium: Scalars['NonNegativeFloat']['input'];
  miniPremium: Scalars['NonNegativeFloat']['input'];
  photographyAndVideographyLebels: Scalars['JSONObject']['input'];
  physicalLossLabels: Scalars['JSONObject']['input'];
  unscheduledBPPLabels: Scalars['JSONObject']['input'];
  /** For non-contractors */
  unscheduledBPPPremium: Scalars['NonNegativeFloat']['input'];
  unscheduledContractorsEquipmentLebels: Scalars['JSONObject']['input'];
  /** For contractors */
  unscheduledContractorsEquipmentPremium: Scalars['NonNegativeFloat']['input'];
  unscheduledHardwareAndSoftwareLabels: Scalars['JSONObject']['input'];
  /** For contractors */
  unscheduledHardwareAndSoftwarePremium: Scalars['NonNegativeFloat']['input'];
  unscheduledSmallToolsLebels: Scalars['JSONObject']['input'];
  /** For contractors */
  unscheduledSmallToolsPremium: Scalars['NonNegativeFloat']['input'];
  valualePapersLebels: Scalars['JSONObject']['input'];
};

export type MunichProratedCalculations = {
  __typename?: 'MunichProratedCalculations';
  GL: MunichGlProratedCalculations;
  IM: MunichImProratedCalculations;
  newCharge: Scalars['Float']['output'];
  prorateFactor: Scalars['NonNegativeFloat']['output'];
  totalPremium: Scalars['NonNegativeFloat']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelationRefund: Scalars['Boolean']['output'];
  /**
   * Broker/admin action: create a hosted Stripe Checkout Session to change the
   * card on file. Only captures the new card by default; charges the outstanding
   * (past-due) installment on the new card ONLY when `settleOutstanding` is true
   * and such an installment exists.
   */
  changeCardSession: BrokerCheckoutSessionResult;
  /**
   * Broker/admin action: create a hosted Stripe Checkout Session to collect
   * either the due installment or the full outstanding balance against a
   * policy's existing Stripe customer. On successful full-outstanding
   * collection the policy's future installments are cancelled by the webhook.
   */
  collectPaymentSession: BrokerCheckoutSessionResult;
  completeRefund: Scalars['Boolean']['output'];
  createPaymentSession: PaymentSessionResult;
  generateSigningURL: Scalars['URL']['output'];
  noOp?: Maybe<Scalars['Boolean']['output']>;
  /** This creates an invoice object in the database and returns a corresponding payment URL. */
  proceedToPayment: Scalars['String']['output'];
  saveInvoice: Scalars['URL']['output'];
  sendCOI: Scalars['Boolean']['output'];
  sendInvoiceLinkEmail: Scalars['Boolean']['output'];
  sendTnCESignature: Scalars['Boolean']['output'];
  storeInvoiceInfo: Scalars['ObjectID']['output'];
};


export type MutationCancelationRefundArgs = {
  invoiceId: Scalars['ObjectID']['input'];
};


export type MutationChangeCardSessionArgs = {
  input: ChangeCardSessionInput;
};


export type MutationCollectPaymentSessionArgs = {
  input: CollectPaymentSessionInput;
};


export type MutationCompleteRefundArgs = {
  creditMemoObjectId: Scalars['ObjectID']['input'];
};


export type MutationCreatePaymentSessionArgs = {
  checkoutInfo?: InputMaybe<ContinuePaymentSessionInput>;
  isContinuing: Scalars['Boolean']['input'];
  paymentInfo?: InputMaybe<CreatePaymentSessionInput>;
};


export type MutationGenerateSigningUrlArgs = {
  quoteOrGroupId: Scalars['ObjectID']['input'];
};


export type MutationProceedToPaymentArgs = {
  quoteId: Scalars['ObjectID']['input'];
};


export type MutationSaveInvoiceArgs = {
  quoteId: Scalars['ObjectID']['input'];
};


export type MutationSendCoiArgs = {
  additionalInsured: CoiAdditionalInsuredInput;
  country: Scalars['String']['input'];
  policyFoxdenId: Scalars['String']['input'];
};


export type MutationSendInvoiceLinkEmailArgs = {
  encryptedString: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
};


export type MutationSendTnCeSignatureArgs = {
  applicationGroupId: Scalars['ObjectID']['input'];
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type MutationStoreInvoiceInfoArgs = {
  invoice: InvoiceInfoInput;
};

export type Name = {
  __typename?: 'Name';
  first: Scalars['String']['output'];
  last: Scalars['String']['output'];
  middle: Scalars['String']['output'];
};

export type NameInput = {
  first: Scalars['String']['input'];
  last: Scalars['String']['input'];
  middle: Scalars['String']['input'];
};

export enum ParentCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Inland Marine */
  Im = 'IM'
}

/**
 * What a broker collect-payment session should charge. Exactly one of the two:
 * the single installment currently due, or the entire outstanding balance.
 */
export enum PaymentCollectionType {
  DueInstallment = 'DUE_INSTALLMENT',
  FullOutstanding = 'FULL_OUTSTANDING'
}

export enum PaymentMethod {
  CreditCard = 'CreditCard'
}

export type PaymentRouteDeciderResults = CancellationSuccess | CancelledRenewalData | ChargeSuccess | FoxdenError | InitialSuccess | IsExpired | IsPaid | RefundFullPaySuccess | RefundInstallmentSuccess | WaiveSuccess;

/**
 * Per-LOB payment-route decisions for an application group. Each field is the
 * decision for that line of business, or null when the group does not carry it.
 */
export type PaymentRouteDeciderResultsByLob = {
  __typename?: 'PaymentRouteDeciderResultsByLob';
  EO?: Maybe<PaymentRouteDeciderResults>;
  GL?: Maybe<PaymentRouteDeciderResults>;
};

export type PaymentSessionResult = ActiveRenewalData | ActiveRenewalFailureData | CancelledRenewalData | CompletionData | InactiveRenewalData | StripeData;

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  effectiveDate?: Maybe<Scalars['String']['output']>;
  invoiceInfo: PaymentStatusInvoiceInfo;
  isPaid: Scalars['Boolean']['output'];
  isRenewalReserved: Scalars['Boolean']['output'];
  isSettled: Scalars['Boolean']['output'];
  policyFoxdenId?: Maybe<Scalars['String']['output']>;
  /**
   * Live URL of a Stripe Checkout Session the BACKEND opened for this
   * ApplicationGroup after a product's charge failed, for the frontend to
   * redirect the customer to. Present only while the group still owes money
   * and such a session is open; null otherwise, including for the sessions
   * createPaymentSession opens, which the frontend already holds the URL for.
   *
   * GROUP-scoped: one retry session covers the whole group, so every product
   * in the response carries the same value.
   */
  stripeCheckoutSessionRedirectUrl?: Maybe<Scalars['String']['output']>;
  transactionStartDate?: Maybe<Scalars['String']['output']>;
};

export type PaymentStatusInvoiceInfo = {
  __typename?: 'PaymentStatusInvoiceInfo';
  client?: Maybe<InvoiceClient>;
};

export enum PolicyCancelReason {
  /** Business Closed */
  BusinessClosed = 'BusinessClosed',
  /** Business Sold */
  BusinessSold = 'BusinessSold',
  /** Found Better Pricing Elsewhere */
  FoundBetterPricingElsewhere = 'FoundBetterPricingElsewhere',
  /** Insurance Is No Longer Required */
  InsuranceIsNoLongerRequired = 'InsuranceIsNoLongerRequired',
  /** Other */
  Other = 'Other'
}

export type PolicyDetail = {
  __typename?: 'PolicyDetail';
  country: Scalars['String']['output'];
  insuredLocation: UnderwritingAddress;
  mailingAddress: UnderwritingAddress;
  namedInsured: Scalars['String']['output'];
  operations: Array<Scalars['String']['output']>;
  policyEndDate: Scalars['Date']['output'];
  policyStartDate: Scalars['Date']['output'];
  timeZone: Scalars['TimeZone']['output'];
};

export type PolicyRemoval = {
  __typename?: 'PolicyRemoval';
  premium?: Maybe<Premium>;
  removal?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
  waivedPremium?: Maybe<WaivedPremium>;
};

export type Premium = {
  __typename?: 'Premium';
  glEarnedPremium: Scalars['Float']['output'];
  glRefundPremium: Scalars['Float']['output'];
  imEarnedPremium: Scalars['Float']['output'];
  imRefundPremium: Scalars['Float']['output'];
};

export enum Provider {
  Stripe = 'Stripe'
}

export type Query = {
  __typename?: 'Query';
  generateRenewalTnC: Scalars['URL']['output'];
  generateTnCDocument?: Maybe<Scalars['String']['output']>;
  /**
   * Resolve a Quote id (legacy T&C links) or an ApplicationGroup id to the
   * owning ApplicationGroup id. Lets the payment frontend canonicalize
   * /terms/<id> links to /terms/<applicationGroupId>.
   */
  getApplicationGroupId: Scalars['ObjectID']['output'];
  getApplicationJurisdiction: GetApplicationJurisdictionResponse;
  getAuth0UserPolicies: Array<Scalars['String']['output']>;
  getCustomerAndBrokerInfo: GetCustomerAndBrokerInfoResponse;
  /**
   * Accepts an invoice id or an ApplicationGroup id; either is resolved up to
   * the ApplicationGroup so every sibling product in the group is considered.
   * Returns a single group-level object, not a per-lobType map:
   * { shouldSendPolicyDocuments: Boolean, stripeCheckoutSessionRedirectUrl?: String }.
   * shouldSendPolicyDocuments is false only when the group's DocuSign envelope
   * is explicitly unsigned. stripeCheckoutSessionRedirectUrl is the live URL of
   * a backend-opened Checkout Session the customer still has to go through;
   * it is absent when the group is fully paid or no such session is open at
   * Stripe. Still modelled as a JSONObject scalar because the shape is plain
   * data forwarded verbatim from the controller.
   */
  getDocuSignEnvelopeSignedStatusByInvoiceOrGroupId: Scalars['JSONObject']['output'];
  getDocumentInformation: DocumentInformation;
  getEmailAddress: Scalars['String']['output'];
  /** This API only returns the invoice only if there's an associated complete payment. */
  getInvoice: GetInvoiceResults;
  getPaymentStatus: Array<GetPaymentStatusResults>;
  getPolicyTaxServiceFeeRate: GetPolicyTaxServiceFeeRateResults;
  getUniqueValueUnderPolicyNumber: GetUniqueValueUnderPolicyNumberResults;
  getUserPaymentPlanOption: Array<UserPaymentPlanOption>;
  /**
   * Accepts an ApplicationGroup id so every sibling product in the group is
   * loaded. Returns a map keyed by lobType (e.g. "GL", "EO"); each value is an
   * array of UserPaymentPlanOptionByQuoteID for that line of business. Modelled
   * as a JSONObject scalar because GraphQL has no native arbitrary-key map type
   * and the resolver returns the per-lob map directly from the controller.
   */
  getUserPaymentPlanOptionsByGroupId: Scalars['JSONObject']['output'];
  noOp?: Maybe<Scalars['Boolean']['output']>;
  /**
   * NCP-4701 — returns the presigned download link for a single customer
   * document (documentType is one of: policyDocument, COI, PaymentReceipt,
   * T_CDocument) and audits the download.
   */
  openCustomerDocument?: Maybe<Scalars['String']['output']>;
  paymentRouteDecider: PaymentRouteDeciderResultsByLob;
};


export type QueryGenerateRenewalTnCArgs = {
  quoteOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGenerateTnCDocumentArgs = {
  answers: Scalars['JSONObject']['input'];
  carrierPartner: Scalars['String']['input'];
  country: Scalars['String']['input'];
  jsonFileName: Scalars['String']['input'];
  rating: Scalars['JSONObject']['input'];
};


export type QueryGetApplicationGroupIdArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetApplicationJurisdictionArgs = {
  quoteOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetCustomerAndBrokerInfoArgs = {
  invoiceIdOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetDocuSignEnvelopeSignedStatusByInvoiceOrGroupIdArgs = {
  invoiceOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetDocumentInformationArgs = {
  policyId: Scalars['String']['input'];
};


export type QueryGetEmailAddressArgs = {
  quoteOrGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetInvoiceArgs = {
  invoiceId: Scalars['ObjectID']['input'];
  placeholder?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryGetPaymentStatusArgs = {
  invoiceId: Scalars['ObjectID']['input'];
  placeholder?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryGetPolicyTaxServiceFeeRateArgs = {
  country: Scalars['String']['input'];
  provinceOrState: Scalars['String']['input'];
};


export type QueryGetUniqueValueUnderPolicyNumberArgs = {
  policyNumber: Scalars['String']['input'];
};


export type QueryGetUserPaymentPlanOptionArgs = {
  InvoiceId: Scalars['ObjectID']['input'];
};


export type QueryGetUserPaymentPlanOptionsByGroupIdArgs = {
  groupId: Scalars['ObjectID']['input'];
};


export type QueryOpenCustomerDocumentArgs = {
  documentType: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type QueryPaymentRouteDeciderArgs = {
  invoiceId: Scalars['ObjectID']['input'];
};

export type QuoteResponse = {
  __typename?: 'QuoteResponse';
  premium: Scalars['Float']['output'];
  quoteId: Scalars['ObjectID']['output'];
  quoteNumber: Scalars['String']['output'];
};

/** This isn't used in the Graphql API; used for generating Typescript type. */
export type QuoteResults = {
  __typename?: 'QuoteResults';
  calculations: MunichCalculations;
  coverageExpiryDate: Scalars['Date']['output'];
  coverageStartDate: Scalars['Date']['output'];
  ratingInput: Scalars['JSONObject']['output'];
};

export type QuoteResultsInput = {
  calculations: MunichCalculationsInput;
  coverageExpiryDate: Scalars['Date']['input'];
  coverageStartDate: Scalars['Date']['input'];
  ratingInput: Scalars['JSONObject']['input'];
};

export type RefundFullPaySuccess = {
  __typename?: 'RefundFullPaySuccess';
  refundedSequence: Array<RefundableSequenceItem>;
};

export type RefundInstallmentSuccess = {
  __typename?: 'RefundInstallmentSuccess';
  result: Scalars['Boolean']['output'];
};

export type RefundableSequenceItem = {
  __typename?: 'RefundableSequenceItem';
  invoiceId: Scalars['ObjectID']['output'];
  paymentIntentId: Scalars['String']['output'];
  refundableAmount: Scalars['NonNegativeFloat']['output'];
  timestamp: Scalars['Date']['output'];
};

export type StripeData = {
  __typename?: 'StripeData';
  session_id: Scalars['String']['output'];
  stripePlatformAccount: Scalars['String']['output'];
};

export enum UsCancellationMethod {
  /** Flat */
  Flat = 'Flat',
  /** Pro Rata */
  ProRata = 'ProRata',
  /** Short Rate */
  ShortRate = 'ShortRate'
}

export enum UsPolicyCancelReason {
  /** Not Taken */
  NotTaken = 'NotTaken',
  /** Other */
  Other = 'Other',
  /** Requested by Insured */
  RequestByInsured = 'RequestByInsured',
  /** Rewritten */
  Rewritten = 'Rewritten'
}

export enum UsRequestDistribution {
  Company = 'Company',
  FinanceCompany = 'FinanceCompany',
  Insured = 'Insured',
  LenderLossPayable = 'LenderLossPayable',
  Lienholder = 'Lienholder',
  LossPayee = 'LossPayee',
  Mortgagee = 'Mortgagee'
}

export type UnderwritingAddress = {
  __typename?: 'UnderwritingAddress';
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  province: Scalars['AbbrevProvinceState']['output'];
  street: Scalars['String']['output'];
};

export type UnderwritingAddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  province: Scalars['AbbrevProvinceState']['input'];
  street: Scalars['String']['input'];
};

export type UniqueValueUnderPolicyNumber = {
  __typename?: 'UniqueValueUnderPolicyNumber';
  subscriptionScheduleId: Scalars['String']['output'];
};

/** Needs to send this URL to customer for signing the Terms & Conditions before the endorsement can take effect. */
export type UpdatePolicyProceedToTerms = {
  __typename?: 'UpdatePolicyProceedToTerms';
  /** The ObjectID for the temporary policy object created by this operation. */
  insertedObjectId: Scalars['ObjectID']['output'];
  /** Does this endorsement possibly require payment or refund */
  isInvolvePayment: Scalars['Boolean']['output'];
  /** The new charge */
  newCharge?: Maybe<Scalars['Float']['output']>;
  /** URL to Docusign page. */
  url: Scalars['URL']['output'];
};

export type UserPaymentPlanOption = {
  __typename?: 'UserPaymentPlanOption';
  downPayment: Scalars['NonNegativeFloat']['output'];
  installmentAmount: Scalars['NonNegativeFloat']['output'];
  installmentFrequency: Scalars['String']['output'];
  invoiceDate: Scalars['Date']['output'];
  invoiceNumber: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  numberOfInstallments: Scalars['NonNegativeFloat']['output'];
  paymentPlan: Scalars['String']['output'];
  paymentPlanId: Scalars['NonNegativeFloat']['output'];
  paymentSchedule: Array<Maybe<Scalars['Date']['output']>>;
  policyInceptionDate: Scalars['Date']['output'];
  quoteNumber: Scalars['String']['output'];
  totalPayable: Scalars['NonNegativeFloat']['output'];
  totalPolicyFees: Scalars['NonNegativeFloat']['output'];
  totalPremiumAmount: Scalars['NonNegativeFloat']['output'];
  totalServiceFees: Scalars['NonNegativeFloat']['output'];
  totalSurcharge: Scalars['NonNegativeFloat']['output'];
  totalTaxes: Scalars['NonNegativeFloat']['output'];
};

export type UserPaymentPlanOptionByQuoteId = {
  __typename?: 'UserPaymentPlanOptionByQuoteID';
  downPayment: Scalars['NonNegativeFloat']['output'];
  installmentAmount: Scalars['NonNegativeFloat']['output'];
  installmentFrequency: Scalars['String']['output'];
  numberOfInstallments: Scalars['NonNegativeFloat']['output'];
  paymentPlan: Scalars['String']['output'];
  paymentPlanId: Scalars['NonNegativeFloat']['output'];
  surcharge: Scalars['Float']['output'];
  totalPayable: Scalars['NonNegativeFloat']['output'];
  totalPolicyFees: Scalars['NonNegativeFloat']['output'];
  totalPremiumAmount: Scalars['NonNegativeFloat']['output'];
  totalServiceFees: Scalars['NonNegativeFloat']['output'];
  totalTaxes: Scalars['NonNegativeFloat']['output'];
};

export type ValidateEndorsementResult = {
  __typename?: 'ValidateEndorsementResult';
  changes: Array<EndorsementChange>;
  effectiveDate: Scalars['Date']['output'];
  isInvolvePayment: Scalars['Boolean']['output'];
};

export type WaiveSuccess = {
  __typename?: 'WaiveSuccess';
  result: Scalars['Boolean']['output'];
};

export type WaivedPremium = {
  __typename?: 'WaivedPremium';
  Canada?: Maybe<Scalars['Float']['output']>;
  GLForUs?: Maybe<Scalars['Float']['output']>;
  IMForUs?: Maybe<Scalars['Float']['output']>;
};

export type GetApplicationJurisdictionResponse = {
  __typename?: 'getApplicationJurisdictionResponse';
  country: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GetCustomerAndBrokerInfoResponse = {
  __typename?: 'getCustomerAndBrokerInfoResponse';
  brokerEmail?: Maybe<Scalars['String']['output']>;
  brokerName?: Maybe<Scalars['String']['output']>;
  customerEmail: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  /**
   * Owning ApplicationGroup id. The payment-frontend sends this to
   * sendTnCESignature (group-scoped e-sign) and builds the canonical
   * /terms/<applicationGroupId> link. The resolver already computes it.
   */
  groupId: Scalars['ObjectID']['output'];
  quoteId?: Maybe<Scalars['ObjectID']['output']>;
};

export type GetApplicationGroupIdQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;


export type GetApplicationGroupIdQuery = { __typename?: 'Query', getApplicationGroupId: string };

export type GetEmailAddressQueryVariables = Exact<{
  quoteOrGroupId: Scalars['ObjectID']['input'];
}>;


export type GetEmailAddressQuery = { __typename?: 'Query', getEmailAddress: string };


export const GetApplicationGroupIdDocument = gql`
    query getApplicationGroupId($id: ObjectID!) {
  getApplicationGroupId(id: $id)
}
    `;
export const GetEmailAddressDocument = gql`
    query getEmailAddress($quoteOrGroupId: ObjectID!) {
  getEmailAddress(quoteOrGroupId: $quoteOrGroupId)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getApplicationGroupId(variables: GetApplicationGroupIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetApplicationGroupIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetApplicationGroupIdQuery>(GetApplicationGroupIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getApplicationGroupId', 'query');
    },
    getEmailAddress(variables: GetEmailAddressQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetEmailAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEmailAddressQuery>(GetEmailAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEmailAddress', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;